import React, {useEffect, useState} from "react";
import { useTranslation } from "react-i18next";
import {Block, FormGroup, Select} from "../../components";
import {Col, Row} from "react-bootstrap";
import { usePropState } from "../../utils";
import {useForm, Yup} from "../../forms/form";

export default function AggregationId({refreshKey, parentFormRef, ...props}) {
  const { t } = useTranslation();
  const [groupByAttributes, setGroupByAttributes] = useState([]);
  const aggregationOptions = props.aggregationOptions;
  const [disabled,] = usePropState(props.disabled);
  const [aggregate,] = usePropState(props.aggregate);
  const [dataType,] = usePropState(props.dataType)
  const {formData, setFormData, getInputProps, validated} = useForm({
    defaultObject: aggregate,
    initialValues: {
      group_by: []
    },
    validationSchema: Yup.object().shape({
      group_by: Yup.array(Yup.string()).min(1).required(),
    }),
    disabled: disabled,
    parentFormRef: parentFormRef,
  });

  useEffect(() => {
    if (aggregationOptions?.hasOwnProperty(dataType)) {
      setGroupByAttributes(aggregationOptions[dataType].group_by.map(el => (Array.isArray(el) ? el[0] : el)));
    }
  }, [aggregationOptions, dataType]);

  useEffect(() => {
    setFormData(aggregate);
  }, [aggregate]);

  return <>
    <Row>
      <Block as={Col} title={t("aggregate.id")}>
        <FormGroup {...getInputProps("group_by")} onChange={(groupBy)=>{setFormData({group_by: [groupBy]})}}>
          <Select options={groupByAttributes} />
        </FormGroup>
      </Block>
    </Row>
  </>
}
